import moment from 'moment';
import { axiosInstance, axiosWithoutInterceptors } from '../routes/axiosInstance';

// Terms of Use and Privacy Policy. Texts and versions come from the API
// (api/users/services/legal.py); only forecasters are ever asked to accept.
export const LEGAL_PATHS = { terms: '/terms', privacy: '/privacy' };

// Public read: no session token, so a stale login can't bounce a reader to
// /signin through the 401 interceptor.
export async function fetchLegalDocument(document, version) {
  const res = await axiosWithoutInterceptors.get(`/user/legal/${document}/`, {
    params: version ? { version } : undefined,
  });
  return res.data.data;
}

export async function fetchPendingLegal() {
  const res = await axiosInstance.get('/user/legal/pending/');
  return res.data.data.pending;
}

export async function acceptLegal(acceptedVersions) {
  const res = await axiosInstance.post('/user/legal/accept/', { accepted_versions: acceptedVersions });
  return res.data.data.pending;
}

// Whether a sign-up invite is for a forecaster (who must accept the Terms).
export async function fetchInviteIsForecaster(token) {
  const res = await axiosWithoutInterceptors.get('/user/register/', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data.data.is_forecaster;
}

// Versions are effective dates (YYYY-MM-DD).
export const formatEffectiveDate = (version) => moment(version, 'YYYY-MM-DD').format('D MMMM YYYY');
